import enviro from 'enviro';
import instanceEditingReducer, { DEFAULT as INITIAL_INSTANCE_EDITING_STATE } from './instanceEditingReducer';
import * as ActionTypes from '../actions/ActionTypes';
import { withUndoableHistory, GROUP_SPLIT_TYPES } from './withUndoableHistory';
export function buildInitialInstanceEditingState(initialState) {
  return {
    past: [],
    future: [],
    groupKey: null,
    currentPresentStart: null,
    undoCount: 0,
    redoCount: 0,
    _skipPastUpdate: false,
    present: Object.assign({}, INITIAL_INSTANCE_EDITING_STATE, initialState),
    futureActionTypes: [],
    pastActionTypes: []
  };
}
const ACTION_TYPES_TO_TRACK = [ActionTypes.UPDATE_CURRENT_INSTANCE_VALUE];
const ACTION_TYPES_TO_GROUP = [ActionTypes.UPDATE_CURRENT_INSTANCE_VALUE];
const filter = action => {
  return ACTION_TYPES_TO_TRACK.includes(action.type);
};
const groupBy = action => {
  const {
    undoData
  } = action;
  if (ACTION_TYPES_TO_GROUP.includes(action.type)) {
    if (undoData && undoData.groupKey) {
      return undoData.groupKey;
    }
    return action.type;
  }
  return null;
};
const FORCE_SPLIT_AFTER_MS = 2000;
const splitGrouping = (action, history) => {
  const {
    undoData
  } = action;

  // If bypassSplit is set, skip all split logic
  if (undoData && undoData.bypassSplit) {
    return GROUP_SPLIT_TYPES.DO_NOT_SPLIT;
  }

  // If splitNext is set, include this action in the current grouping,
  // but the next action should start a new grouping.
  if (undoData && undoData.splitNext) {
    return GROUP_SPLIT_TYPES.SPLIT_NEXT;
  }

  // Check if enough time has passed since the start of this grouping to split it.
  const currentTime = Date.now();
  const currentPresentStart = history.currentPresentStart;
  if (currentPresentStart) {
    const elapsedTime = currentTime - currentPresentStart;
    if (elapsedTime > FORCE_SPLIT_AFTER_MS) {
      return GROUP_SPLIT_TYPES.SPLIT_NOW;
    }
  }

  // Allow this action to be grouped
  return GROUP_SPLIT_TYPES.DO_NOT_SPLIT;
};
const createUndoableScpReducer = reducer => withUndoableHistory(reducer, {
  debug: Boolean(enviro.debug('SCP_DEBUG_UNDO_REDO')) || false,
  ignoreInitialState: true,
  // Don't allow undoing back to the empty state
  filter,
  groupBy,
  limit: 50,
  redoType: ActionTypes.REDO_EDIT,
  splitGrouping,
  undoType: ActionTypes.UNDO_EDIT
});
export default createUndoableScpReducer(instanceEditingReducer);